'use strict';

const $ = jQuery.noConflict();

$(function() {
	const brandAnimationFade = {
		init: function() {
			this.cacheDOM();
			this.bindObserver();
		},

		cacheDOM: function() {
			this.$sections = $('.js-brand-animation-fade');
		},

		bindObserver: function() {
			if (!this.$sections.length || !('IntersectionObserver' in window)) {
				return;
			}

			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				return;
			}

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('is-visible');
						observer.unobserve(entry.target);
					}
				});
			}, {threshold: 0.6});

			this.$sections.each((_, section) => observer.observe(section));
		},
	};

	brandAnimationFade.init();
});
